var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.55794 14C5.06961 13.0488 -0.300583 9.87654 1.29212 7.19786C3.283 3.8495 6.07997 0.0564282 8.29889 1.21186C10.5178 2.36729 15.1397 5.90892 13.7412 7.80547C12.6225 9.32272 10.3546 12.543 9.07271 13.6829M7.10731 10.842C7.27913 11.05 7.56199 11.1098 7.79506 10.9686C8.02362 10.8302 8.13233 10.5421 8.07646 10.2732M7.10731 10.842C7.07651 10.8048 7.04928 10.7627 7.02655 10.7162C6.87696 10.4104 6.97851 10.0275 7.25336 9.86108C7.52821 9.69463 7.87228 9.80762 8.02187 10.1135C8.04707 10.165 8.06514 10.2187 8.07646 10.2732M7.10731 10.842C7.35771 10.9424 7.9021 10.9693 8.07646 10.2732M7.3334 8.65432C6.96198 6.8691 6.5624 3.95455 7.42252 3.95455C8.28264 3.95455 7.88306 6.8691 7.51164 8.65432C7.48701 8.7727 7.35803 8.7727 7.3334 8.65432Z",
    stroke: "black",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ddb1b7e521017ea20724c29826de55e7.svg";
export { ForwardRef as ReactComponent };